import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=0bbe9b66&scoped=true&"
import script from "./tasks.vue?vue&type=script&lang=js&"
export * from "./tasks.vue?vue&type=script&lang=js&"
import style0 from "./tasks.vue?vue&type=style&index=0&id=0bbe9b66&scoped=true&lang=css&"
import style1 from "./tasks.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe9b66",
  null
  
)

export default component.exports